import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { socialMedia } from '@config';
import { Side } from '@components';
import { Icon } from '@components/icons';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    a {
      padding: 10px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: var(--transition);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));

      @media (hover: hover) {
        &:hover,
        &:focus-visible {
          transform: translateY(-3px);
          color: #ff2a2a;
          filter: drop-shadow(0 0 5px rgba(255, 42, 42, 0.6));
        }
      }
      &:active,
      &.touch-active {
        transform: translateY(-3px);
        color: #ff2a2a;
        filter: drop-shadow(0 0 5px rgba(255, 42, 42, 0.6));
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  @media (max-height: 450px) and (orientation: landscape) {
    &:after {
      height: 30px;
    }
  }
`;

const Social = ({ isHome }) => (
  <Side isHome={isHome} orientation="left">
    <StyledSocialList>
      {socialMedia &&
        socialMedia.map(({ url, name }, i) => (
          <li key={i}>
            <a
              href={url}
              aria-label={name}
              target="_blank"
              rel="noreferrer"
              onClick={e => e.currentTarget.blur()}
            >
              <Icon name={name} />
            </a>
          </li>
        ))}
    </StyledSocialList>
  </Side>
);

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
